/* eslint-disable max-len */
export default function Cloud() {
  return (
    <svg width="152" height="86" viewBox="0 0 152 86" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_1419_753)">
        <path
          d="M126.249 85.0014L126.165 85.0059L25.0321 84.9586C11.5686 83.8849 1 73.3773 1 58.9599C1 44.5363 12.7037 32.8429 27.1443 32.8429C29.1141 32.8429 31.0322 33.0817 32.8949 33.4996L33.8422 33.7122L34.0827 32.7716C38.7512 14.5096 55.0984 1 74.9952 1C94.8905 1 111.53 14.7494 116.029 33.24L116.279 34.264L117.288 33.9615C119.689 33.2418 122.225 32.8429 124.856 32.8429C139.285 32.8429 151 45.0161 151 58.9599C151 72.9073 140.035 84.2712 126.249 85.0014Z"
          stroke="black"
          stroke-width="2"
        />
        <path
          d="M90.5507 39.6658L76.4302 25.5595C76.193 25.3226 75.8018 25.3226 75.5647 25.5595L61.4442 39.6658C60.4305 40.6785 60.5609 42.4018 61.8236 43.2368C62.7424 43.8409 63.9814 43.6632 64.7579 42.8815L73.6914 33.957V61.9209C73.6914 63.0224 74.4384 64.0232 75.5173 64.2423C76.9993 64.5443 78.3094 63.4132 78.3094 61.986V33.951L87.2844 42.917C87.723 43.3553 88.298 43.5921 88.9205 43.5921C89.5429 43.5921 90.1179 43.3493 90.5507 42.917C90.9894 42.4788 91.2265 41.9044 91.2265 41.2825C91.2265 40.6607 90.9834 40.0863 90.5507 39.6481V39.6658Z"
          fill="#2C2926"
        />
      </g>
      <defs>
        <clipPath id="clip0_1419_753">
          <rect width="152" height="86" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
